import { RecommendationsDataProps } from "../../lib/dashboard/insights/types";
import { createFilteredUrlParams } from "../utils/createFilteredUrlParams";

const insightsEndpoint = "/api/dashboard/insights/recommendations";
const streamEndpoint = "/api/dashboard/insights/recommendations/stream";

type InsightsRecommendations = Omit<RecommendationsDataProps, "metricName">;

const ENDPOINTS = {
  fetchInsightsRecommendations: (params: RecommendationsDataProps) => {
    const { metricName, ...filteredParams } = params;
    return `${insightsEndpoint}/${metricName}?${createFilteredUrlParams<InsightsRecommendations>(
      filteredParams,
    )}`;
  },
  streamInsightsRecommendations: (params: RecommendationsDataProps) => {
    const { metricName, ...filteredParams } = params;
    return `${streamEndpoint}/${metricName}?${createFilteredUrlParams<InsightsRecommendations>(
      filteredParams,
    )}`;
  },
};

export { ENDPOINTS };
